import React from 'react'
import { OutlinedInput, OutlinedInputProps } from '@mui/material'
import styles from './Input.module.scss'

interface InputProps extends OutlinedInputProps {
  label?: string
  errorText?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, type = 'text', error, errorText, ...rest }, ref) => {
    return (
      <div className={styles.inputRoot}>
        {label && <label className={styles.label}>{label}</label>}
        <OutlinedInput
          {...rest}
          inputRef={ref}
          className={`${styles.input} ${error ? styles.error : ''}`}
          error={error}
        />
        {error && errorText && (
          <div className={styles.errorText}>{errorText}</div>
        )}
      </div>
    )
  }
)

export default Input
